import { AttachmentBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-attachment';
import { BookmarkBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-bookmark';
import { CodeBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-code';
import { DatabaseBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-database';
import { DividerBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-divider';
import {
  EmbedFigmaBlockNotionHtmlAdapterExtension,
  EmbedGithubBlockNotionHtmlAdapterExtension,
  EmbedLoomBlockNotionHtmlAdapterExtension,
  EmbedYoutubeBlockNotionHtmlAdapterExtension,
} from '@blocksuite/hive-block-embed';
import { ImageBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-image';
import { LatexBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-latex';
import { ListBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-list';
import { ParagraphBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-paragraph';
import { RootBlockNotionHtmlAdapterExtension } from '@blocksuite/hive-block-root';
import type { ExtensionType } from '@blocksuite/store';

export const defaultBlockNotionHtmlAdapterMatchers: ExtensionType[] = [
  ListBlockNotionHtmlAdapterExtension,
  ParagraphBlockNotionHtmlAdapterExtension,
  CodeBlockNotionHtmlAdapterExtension,
  DividerBlockNotionHtmlAdapterExtension,
  ImageBlockNotionHtmlAdapterExtension,
  RootBlockNotionHtmlAdapterExtension,
  BookmarkBlockNotionHtmlAdapterExtension,
  DatabaseBlockNotionHtmlAdapterExtension,
  LatexBlockNotionHtmlAdapterExtension,
  EmbedYoutubeBlockNotionHtmlAdapterExtension,
  EmbedFigmaBlockNotionHtmlAdapterExtension,
  EmbedGithubBlockNotionHtmlAdapterExtension,
  EmbedLoomBlockNotionHtmlAdapterExtension,
  AttachmentBlockNotionHtmlAdapterExtension,
];
